import { Validation } from '@surveycake/logic-engine';
import { scrollToSubject } from 'app/modules/subject';

/**
 * The handler for validation result of engine.
 */
export function handleEngineValidation(
  validation: Validation,
  onResolve?: () => void,
  onReject?: () => void
) {
  if (!validation) {
    return;
  }

  const { status, subjects } = validation;

  if (status) {
    if (onResolve) {
      onResolve();
    }
  } else {
    /**
     * Scroll to the first subject which has error.
     */
    if (subjects && subjects.violator) {
      scrollToSubject(subjects.violator);
    }

    if (onReject) {
      onReject();
    }
  }
}
